import { render, staticRenderFns } from "./PersonalDataCard.vue?vue&type=template&id=311e35f2&scoped=true"
import script from "./PersonalDataCard.vue?vue&type=script&lang=js"
export * from "./PersonalDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e35f2",
  null
  
)

export default component.exports